export const AVAILABLE_CONTRACT_ITEMS = [
  {
    contract_line: "10",
    tender_line: "10",
    description: "SURFACE DRESSING, SITE CLEARANCE/CLVRT 176050300066",

    uom: "square meter",
    rate: "8.80",
  },
  {
    contract_line: "20",
    tender_line: "20",
    description: "EXCAVATION, F/FNDTN, GRND LVL UPTO 1.5M 520903300026",

    uom: "cubic meter",
    rate: "140.80",
  },
  {
    contract_line: "30",
    tender_line: "30",
    description: "EXCAVATION, F/FNDTN, GRND LVL UPTO 3M 520604300022",

    uom: "cubic meter",
    rate: "246.40",
  },
  {
    contract_line: "40",
    tender_line: "40",
    description: "EXCAVATION, F/FNDTN, BTWN 3-4.5M 520903300024",

    uom: "cubic meter",
    rate: "352.00",
  },
  {
    contract_line: "50",
    tender_line: "50",
    description: "EXCAVATION, F/FNDTN, HR, GRND, UPTO 1.5M 520903300009",

    uom: "cubic meter",
    rate: "400.00",
  },
  {
    contract_line: "60",
    tender_line: "60",
    description: "EXCAVATION, F/FNDTN, HR, GRND, 1.5-3M 520903300008",

    uom: "cubic meter",
    rate: "532.00",
  },
  {
    contract_line: "70",
    tender_line: "70",
    description: "EXCAVATION, F/FNDTN, HR, BTWN 3-4.5M 520903300023",
    uom: "cubic meter",
    rate: "3656.62",
  },
  {
    contract_line: "80",
    tender_line: "80",
    description: "SUPPLY AND FILLING, WITH CLEAN, 49RU000008 520550300076",
    uom: "cubic meter",
    rate: "720.3",
  },
  {
    contract_line: "90",
    tender_line: "90",
    description: "SUPPLY&FILLING, CRSHD STN SND FLNG, 150MM 520450300003",
    uom: "cubic meter",
    "rate": "1,340.00",
  },
  {
    contract_line: "100",
    tender_line: "100",
    description: "SUPPLY AND FILLING FOR PAYMEN, 49RU000010 520402300007",
    uom: "cubic meter",
    rate: "583.20",
  },
];
